import { IntegrationType } from 'constants/integrations';
import { useState } from 'react';
import { useAdAccountStore } from 'stores';
import { useFacebook, useIntegrations, useShowSpinner } from 'hooks';
import { FacebookIntegrationModalProps } from 'types/components/integrations';
import DisconnectIntegrationModal from 'ui/Modals/DisconnectIntegrationModal';
import FacebookIntegrationModalView from './FacebookIntegrationModal.View';
import { useParams } from 'react-router-dom';

const FacebookIntegrationModal = (
  props: Pick<FacebookIntegrationModalProps, 'open' | 'onClose'>
) => {
  const { open, onClose } = props;
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const { deleteIntegration, getActiveIntegrations, loading } = useIntegrations();
  const { getMetaStatus, onAcceptTermsClick, onConnectAdAccountClick } = useFacebook();
  const { brandId } = useParams<{ brandId: string }>();
  const adAccountStore = useAdAccountStore();

  useShowSpinner({ show: loading });

  const { metaAdAccount } = adAccountStore;
  const [facebookIntegration] = getActiveIntegrations(IntegrationType.Facebook);

  const onDisconnectClick = () => setDisconnectModalOpen(true);

  const onDisconnectConfirm = async () => {
    if (facebookIntegration) {
      setDisconnectModalOpen(false);
      await deleteIntegration(facebookIntegration.integrationId);
      adAccountStore.clear(IntegrationType.Facebook);
    }
  };

  const fbIntegrationStatus = getMetaStatus();

  return (
    <>
      <FacebookIntegrationModalView
        brandId={brandId as string}
        status={fbIntegrationStatus}
        onConnectAdAccountClick={onConnectAdAccountClick}
        onDisconnectClick={onDisconnectClick}
        onAcceptTermsClick={onAcceptTermsClick}
        adAccount={metaAdAccount}
        loading={loading}
        open={open}
        onClose={onClose}
      />
      <DisconnectIntegrationModal
        type={IntegrationType.Facebook}
        open={disconnectModalOpen}
        close={() => setDisconnectModalOpen(false)}
        confirm={onDisconnectConfirm}
      />
    </>
  );
};

export default FacebookIntegrationModal;
